<template>
  <div class="hell">
    <div id="hidebg"></div>
    <div class="Bulletframe" v-show="guanbi">
      <div class="fwbtext" v-html="this.textarea2"></div>

      <el-button type="primary" style="margin-bottom: 30px; opacity: 0.6; width: 150px; font-size: 17px" @click="know()"
        round>我知道了</el-button>
    </div>
    <div class="header">
      <img @click="logo" src="../assets/logo.png" alt style="cursor: pointer;" />
      <p @click="logo" style="cursor: pointer;">创新与知识产权管理人才服务系统</p>
    </div>
    <div class="login">
      <div class="login_div">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" size="mini"
          class="login-form">
          <el-form-item style="text-align: center">
            <span class="regTitle">用户注册</span>
          </el-form-item>
          <el-form-item prop="userName" label="姓名：" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.userName" type="text" auto-complete="off" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="证件类型：" prop="idcardType" :label-width="formLabelWidth" class="IdCard">
            <!-- @change="getLastChangeIndex(item)" -->
            <el-select v-model="ruleForm.idcardType" placeholder="请选择" @change="getLastChangeIndex($event)">
              <el-option v-for="(item, index) in idCardList" :key="index" :label="item.value"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <!-- </div> -->
          <div style="height: 10px"></div>
          <el-form-item prop="idcardNum" label="证件号码：" :label-width="formLabelWidth" style="margin-top: -7px">
            <el-input v-model="ruleForm.idcardNum" type="text" auto-complete="off" placeholder="请输入证件号码"
              @blur="checkIdcard"></el-input>
          </el-form-item>
          <el-form-item prop="sex" label="性别：" :label-width="formLabelWidth" style="text-align: left">
            <el-radio-group v-model="ruleForm.sex" :disabled="ruleForm.idcardType=='1'">
              <el-radio v-for="(item, index) in sexList" :key="index" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="mobilePhone" label="联系手机：" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.mobilePhone" type="text" auto-complete="off" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item prop="checkCode" label="手机验证码：" :label-width="formLabelWidth">
            <div style="display: flex;">
              <el-input v-model="ruleForm.checkCode" type="text" auto-complete="off" placeholder="请输入手机验证码"></el-input>
              <el-button type="success" @click="getCode" size="small" :disabled="disabled" v-show="is_pause == false"
                >获取验证码</el-button>
              <span v-show="is_pause == true" style="display: inline-block;width: 200px;">有效时间：{{ countdown }}s</span>
            </div>
          </el-form-item>
          <el-form-item label="电子邮箱：" :label-width="formLabelWidth" prop="emails">
            <el-input v-model="ruleForm.emails" type="text" auto-complete="off" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>

          <el-form-item v-if="visible" prop="passwd" label="密码：" :label-width="formLabelWidth">
            <el-input placeholder="请输入密码" v-model="ruleForm.passwd" type="text" auto-complete="off"
              @keyup.enter.native="handleLogin"></el-input>
            <img src="../image/iframe/looky.png" @click="showPass('show')" class="icon-yincan scrimg" />
          </el-form-item>

          <el-form-item class="looky" v-else prop="passwd" label="密码：" :label-width="formLabelWidth">
            <el-input placeholder="请输入密码" v-model="ruleForm.passwd" type="password" auto-complete="new-password"
              @keyup.enter.native="handleLogin"></el-input>
            <img src="../image/iframe/lookn.png" @click="showPass('show')" class="icon-xianshi scrimg" />
          </el-form-item>
          <el-form-item v-if="visiblea" prop="passwords" label="确认密码：" :label-width="formLabelWidth">
            <el-input placeholder="请输入确认密码" v-model="ruleForm.passwords" type="text" auto-complete="off"
              @keyup.enter.native="handleLogin"></el-input>
            <img src="../image/iframe/looky.png" @click="showPassa('show')" class="icon-yincan scrimg" />
          </el-form-item>

          <el-form-item class="looky" v-else prop="passwords" label="确认密码：" :label-width="formLabelWidth">
            <el-input placeholder="请输入确认密码" v-model="ruleForm.passwords" type="password" auto-complete="off"
              @keyup.enter.native="handleLogin"></el-input>
            <img src="../image/iframe/lookn.png" @click="showPassa('show')" class="icon-xianshi scrimg" />
          </el-form-item>

          <!-- <div style="height: 10px"></div> -->
          <!-- <div style="display: flex" class="yanzhenma">
            <el-form-item prop="check_code" label="验证码：" :label-width="formLabelWidth">
              <el-input style="width: 350px; display: flex; align-items: center" placeholder="请输入验证码"
                v-model="ruleForm.check_code"></el-input>
            </el-form-item>

            <div style="width: 120px; height: 38px;display: flex;align-items: center;justify-content: space-around;">
              <img style="width: 60%; height: 100" :src="register.image" @click="Changeone()" />
              <span style="color: red;">两位字符验证码</span>
            </div> -->

            <!-- <p
              style="
                width: 120px;
                height: 38px;
                display: flex;
                align-items: center;
              "
              @click="Changeone()"
            >
              看不清&nbsp;换一张
            </p> -->
            <!-- </el-form-item> -->
          <!-- </div> -->
          <!-- <div style="hieght: 20px; width: 100%"></div> -->
          <el-form-item prop="agreed" class="read">
            <div class="controls">
              <el-checkbox v-model="ruleForm.agreed">阅读并接受</el-checkbox>
              <a style="color: #2e58ff" @click="read(1)">《用户服务协议》</a>
              <span>及</span>
              <a style="color: #2e58ff" @click="read(2)">《用户隐私保护政策》</a>
            </div>
          </el-form-item>
          <div style="height: 10px"></div>
          <el-form-item style="width: 100; margin: auto; margin-bottom: 20px" :label-width="formLabelWidth">
            <el-button :loading="loading" size="medium" type="primary" style="width: 100%"
              @click.native.prevent="handleLogin">
              <span v-if="!loading">注&nbsp;&nbsp;册</span>
              <span v-else>注 册 中...</span>
            </el-button>
          </el-form-item>

          <!-- <el-form-item style="width: 100%; margin-top: 20px">
            <a @click="gosignin" class="register">有账号 去登录</a>
          </el-form-item>-->
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 加密

//此处引入富文本
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  enterpriselogincode,
  registUser,
  logins,
  thirdPartyCheckVaild,
  // getCheckRepeat
  checkRepeat,
  getDictInfoNew,
  sendSmsCaptcha,
  checkIsRegist
} from "@/api/api.js";
import { get } from "jquery";
export default {
  enterprise_name: "Login",
  data() {
    var checkphone = (rule, value, callback) => {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!this.isCellPhone(value)) {
        // 引入methods中封装的检查手机格式的方法
        callback(new Error("请输入正确的手机号!"));

      } else if (value != "" && this.isCellPhone(value)) {
        let parames = {
          value: this.ruleForm.mobilePhone, //enterprise_name：企业名称  credit_code：统一社会信用代码  account：登录账号
          type: 2,
        };
        checkRepeat(parames).then((res) => {
          if (res.code == "1000") {
            if (!res.data) {
              this.disabled = true;
              return callback(new Error("手机号已存在")); //false 为已绑定 true 为未绑定校验通过
            } else {
              this.disabled = false
              callback();
            }
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    };

    let checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else {
        let reg =
          /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@$!%*?&#:;,.-/~<>|{}+_()="^\\[\]`-])[a-zA-Z\d@$!%*?&#:;,.-/~<>|{}+_()="^\\[\]`-]{8,16}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(
            new Error(
              "请输入8-16位同时包含数字、字母大小写及特殊字符#@!~%^&*_$的组合"
            )
          );
        }
      }
    };
    // 校验身份证号唯一性
    let checkIdcard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证件号码"));
      } else {
        if (this.ruleForm.idcardType == 1) {
          const reg =
            /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if (!reg.test(this.ruleForm.idcardNum)) {
            const msg = rule.msg ? rule.msg : "身份证格式不正确";
            return callback(new Error(msg));
          } else {
            return callback();
          }
        }
      }
    };
    //校验手机号
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        let parames = {
          value: this.ruleForm.mobilePhone, //enterprise_name：企业名称  credit_code：统一社会信用代码  account：登录账号
          type: 2,
        };
        checkRepeat(parames).then((res) => {
          if (res.code == "1000") {
            if (!res.data) {
              return callback(new Error("手机号已存在")); //false 为已绑定 true 为未绑定校验通过
            } else {
              callback();
            }
          } else {
            callback();
          }
        });
      }
    };
    // 校验邮箱
    let checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      } else {
        let parames = {
          value: this.ruleForm.emails, //enterprise_name：企业名称  credit_code：统一社会信用代码  account：登录账号
          type: 3,
        };
        // console.log("5555", this.idcardNum);
        checkRepeat(parames).then((res) => {
          console.log("身份唯一", res);
          if (res.code == "1000") {
            if (!res.data) {
              return callback(new Error("电子邮箱已存在")); //false 为已绑定 true 为未绑定校验通过
            } else {
              callback();
            }
          } else {
            callback();
          }
        });
      }
    };
    // 短信验证码
    const codeMsg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else {
        let reg = /^[0-9]{6}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入六位数字验证码"));
        }
      }
    };
    return {
      formLabelWidth: "120px",
      register: { image: "", uuid: "" },
      dynamicValidateForm: {},
      textarea2: "",
      conceal: "../image/iframe/lookn.png",
      show: "../image/iframe/looky.png",
      visible: false,
      visiblea: false,
      guanbi: false,
      codeUrl: "",
      cookiePass: "",
      rememberMe: false,
      ruleForm: {
        // textarea: '请仔细阅读以下协议',
        agreed: false,
        userName: "", //姓名
        sex: "", //性别
        account: "", //账户
        passwd: "", //密码
        emails: "", //邮箱
        mobilePhone: "", //电话号码
        idcardType: "", //证件类型
        idcardNum: "",
        check_uuid: "",
        check_code: "",
        checkCode: ""
      },
      sexList: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
      ],
      idCardList: [],
      rules: {
        agreed: [
          {
            validator: (rule, value, callback) => {
              if (value !== true) {
                callback(new Error("请阅读并勾选"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        userName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          {
            max: 20,
            min: 2,
            message: "请输入2-20位字符",
            trigger: ["blur", "change"],
          },
          // { validator: checkAccount, trigger: "blur" }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        idcardType: [
          { required: true, message: "请选择身份证件类型", trigger: "change" },
        ],
        idcardNum: [
          { required: true, message: "证件号码不能为空", trigger: "blur" },
          { required: true, validator: checkIdcard, trigger: ["blur", "change"] },
        ],
        mobilePhone: [
          {
            required: true,
            validator: checkphone,
            trigger: ["blur", "change"],
          },
          // { validator: checkMobile, trigger: "blur" }
        ],
        checkCode: [
          {
            required: true,
            message: "短信验证码不能为空",
            trigger: "blur",
          },
          {
            validator: codeMsg,
            trigger: "blur",
          },
        ],

        emails: [
          { required: true, message: "电子邮箱不能为空", trigger: "blur" },
          {
            type: "email",
            max: 50,
            min: 9,
            message: "请输入正确的电子邮箱",
            trigger: ["blur", "change"],
          },
          { validator: checkEmail, trigger: "blur" },
        ],
        // check_code: [
        //   { required: true, message: "验证码不能为空", trigger: "blur" },
        // ],

        passwd: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            min: 8,
            max: 16,
            message:
              "请输入8-16位同时包含数字、字母大小写及特殊字符#@!~%^&*_$的组合",
            trigger: ["blur", "change"],
          },
          { validator: checkPass, trigger: "blur" },
        ],
        passwords: [
          {
            required: true,
            message: "确认密码不能为空",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请再次输入密码"));
              } else if (value !== this.ruleForm.passwd) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },

      loading: false,
      redirect: undefined,
      countdown: 0, //倒计时
      countdownNum: 0,
      timer: null, //定时器
      is_pause: false, //是否暂停
      disabled: true,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
    // "ruleForm.mobilePhone": {
    //   handler(newname, oldname) {
    //     if (!/^1(3|4|5|6|7|8)\d{9}$/.test(newname)) {
    //       this.disabled = true;
    //     } else {
    //       this.disabled = false;
    //     }
    //   },
    // },
  },
  mounted() {
    this.initTable();
    getDictInfoNew("ZJLX").then((res) => {
      console.log(res);
      this.idCardList = res.data;
    });
  },
  created() {
    // this.ruleForm.emails = ''
    this.initTable();
  },
  methods: {
    timeFn() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          // 倒计时结束后需要执行的操作
          this.is_pause = false;
          this.disabled = false;
        }
      }, 1000);
    },
    // 获取验证码
    getCode() {
      if (this.ruleForm.mobilePhone == "") {
        this.$message.warning("请输入手机号");
        return false;
      }
      sendSmsCaptcha(
        this.$qs.stringify({ code: this.ruleForm.mobilePhone,exist:false })
      ).then((res) => {
        if (res.code == 1000) {
          this.$message.success("发送成功请留意短信");
          this.countdown = "120";
          this.is_pause = true;
          this.disabled = true;
          this.timeFn();
        } else {
          this.is_pause = false;
          this.disabled = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 身份证验证
    accountFn() {
      if (this.ruleForm.idcardType == "1") {
        const reg =
          /^[1-9]\d{5}(19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!reg.test(this.ruleForm.idcardNum)) {
          this.$message.error("身份证格式不正确");
          // this.ruleForm.idcardNum = "";
          return;
        }
      }
    },
    checkIdcard() {
      // 示例
      const reg =
            /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (this.ruleForm.idcardType == "1" && reg.test(this.ruleForm.idcardNum)) {
        const idNumber = this.ruleForm.idcardNum;
        var sex = idNumber.substring(16, 17)
        if (sex % 2 == 0) {
          this.ruleForm.sex = 2
        } else {
          this.ruleForm.sex = 1
        }
      }
    },

    getLastChangeIndex(val) {
      this.ruleForm.idcardType = val;
    },
    getChange() {
      console.log("1111");
    },
    agree() { },
    // 账号获取焦点

    //查看协议
    read(val) {
      if (val == 2) {
        this.textarea2 = `
        <h1 style="text-align:center">
    <span style="font-size: 24px;">用户隐私保护政策</span>
</h1>
<p>
    <br/>
</p>
<p style="text-align:center">
    <span style=";font-family:等线">版本生效日期：2023年【06】月【16】日</span>
</p>
<p>
    <span style=";font-family:等线"><br/></span>
</p>
<p>
    <span style=";font-family:等线"><br/></span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph">
    <span style="font-size: 16px;"><strong><span style="font-family: 等线;">欢迎您使用创新与知识产权管理人才服务系统（下称“人才服务系统”）的产品和服务！ </span></strong></span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph">
    <span style="font-size: 16px;"><strong><span style="font-family: 等线; font-size: 16px;">&nbsp;</span></strong></span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph">
    <span style="font-size: 16px;"><span style="font-family: 等线; font-size: 16px;">创新管理标准化国际伙伴计划</span><span style="font-family: 等线; font-size: 16px;">（以下简称“我们”）一向重视用户（“您”）的个人信息及隐私的保护，我们深知个人信息对您的重要性，并严格遵循法律法规，竭力保障您的信息安全。鉴于此，我们制定本《用户隐私保护政策》（下称“本隐私政策”）并提醒您：本隐私政策适用于我们的人才服务系统，您在享受我们提供服务的同时，我们会收集和使用您相关的个人信息，我们希望通过本隐私政策向您说明我们在您使用我们人才服务系统时如何收集、使用、保存、提供、删除、共享和转让这些个人信息，以及我们为您提供的查询、复制、删除和保护这些信息的方式。</span></span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph">
    <span style="font-family: 等线; font-size: 16px;">&nbsp;</span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph">
    <span style="font-size: 16px;"><strong><span style="font-family: 等线; font-size: 16px;">希望您仔细阅读本隐私政策，详细了解我们对个人信息的收集、使用、对外提供或其他处理的情况。您点击同意本隐私政策并开始使用人才服务系统，表示您知悉并同意我们按照本隐私政策处理您的个人信息，并在法律规定及本隐私政策约定的范围内进行使用。如果您有任何疑问，您可通过本隐私政策规定的联系电话【010-64754680】或电子邮件<span style="font-size: 16px;">【info@imspp.org.cn】</span>的形式与我们联系，我们将尽快为您解答。</span></strong></span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph">
    <strong><span style=";font-family: 等线"><br/></span></strong>
</p>
<p style="text-align:justify;text-justify:inter-ideograph">
    <span style="font-size: 16px;"><strong><span style="font-family: 等线;"><br/></span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong>一、</strong><strong>我们如何收集和使用您的个人信息</strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">二、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们如何使用</span></strong><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">Cookie </span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">和同类技术</span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">三、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们如何共享、转让、公开披露您的个人信息</span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">四、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">如何保护您的个人信息</span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">五、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们如何存储您的个人信息</span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">六、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">您的个人信息权利</span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">七、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">未成年人保护</span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">八、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">本隐私政策更新</span></strong></span>
</p>
<p style="line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">九、</span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">联系我们</span></strong></span>
</p>
<p style="margin-bottom:21px;line-height:150%">
    <span style="font-size: 16px;"><strong><br/></strong></span>
</p>
<p style="margin-bottom:21px;line-height:150%">
    <span style="font-size: 16px;"><strong>&nbsp; &nbsp;&nbsp; 一<strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">、<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们如何收集和使用您的个人信息</span></strong></strong></span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph;text-indent:32px">
    <span style="font-family: 等线; font-size: 16px;">个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹信息，以及不满十四周岁未成年人的个人信息。</span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph;text-indent:32px">
    <span style="font-family: 等线; font-size: 16px;">我们会在以下场景中收集您的个人信息。<strong>对于其中可能涉及的敏感个人信息，我们以加粗的显著方式提醒您注意。</strong>如果您提供的个人信息非本人信息，您应确保您已获得本人的授权同意。</span>
</p>
<p style="text-align:justify;text-justify:inter-ideograph;text-indent:32px">
    <span style="font-family: 等线; font-size: 16px;"><br/></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-size: 16px;">1.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">账号管理</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">a)<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">注册</span><span style="line-height: 150%; font-size: 16px;">/</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">登录账号</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">当您使用浏览器打开人才服务系统并注册</span><span style="line-height: 150%; font-size: 16px;">/</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">登录账号时，我们需要收集、使用绑定您的手机号及电子邮箱。为了了解我们用户类型，您在首次注册账号时，需填写个人基本信息，个人基本信息包含：<span style="font-size: 16px;">人物头像、姓名、性别、证件类型、证件号码、联系手机、电子邮箱、职称及详细地址等。</span></span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">b)<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">个人中心</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">在您成功注册账号之后，您可以通过“个人中心”修改您的个人信息及工作信息。工作信息包含：<span style="line-height: 150%; font-family: 宋体;font-size: 16px;">单位名称、统一社会信用代码、技术领域、所在部门、所在岗位、单位详细地址等。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-size: 16px;">2.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">您个人及企业信息使用的规则</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:10px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们严格遵守法律法规的规定和本隐私政策的约定，为实现我们的产品或服务功能对所收集的个人及企业信息，出于以下目的使用您的个人及企业信息。若我们超出以下用途或者将基于特定目的收集而来的信息用于其他目的使用您的信息，我们将再次向您进行说明，并征得您的同意：</span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">a)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">帮助您成为我们的用户；</span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">b)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">向您提供服务；</span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">c)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">邀请您参与有关我们服务的调查，评估、改善我们的服务及推广活动的效果；</span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">d)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">将所收集到的信息用于数据分析。我们将收集到的信息用于分析形成不包含任何个人信息的行业洞察报告；</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">e)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">为您提供安全保障。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">二、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp;&nbsp; </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们如何使用</span></strong><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">Cookie </span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">和同类技术</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">1.&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">为确保我们的产品、服务的正常开展、为您获得更轻松的访问体验，我们会在您移动设备上存储名为</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">的小数据文件。</span><span style="line-height: 150%; font-size: 16px;">Cookie&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">通常包含标识符、站点名称以及一些号码和字符。</span><span style="line-height: 150%; font-size: 16px;">Cookies</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">及其同类技术可帮助我们改进我们的网站以及您的体验。我们使用</span><span style="line-height: 150%; font-size: 16px;">Cookies</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">来判断哪些领域和功能受到欢迎，并且计算您访问我们网站的次数。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">2.&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">如您不希望个人信息保存在</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">中，您可对浏览器进行配置，选择禁用</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">功能。禁用</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">功能后，可能影响您访问贯标学习系统的部分功能。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">3.&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们不会将</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">用于本指引所述目的之外的任何用途。您可根据自己的偏好管理或删除</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">。您可以清除计算机上保存的所有</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">，大部分网络浏览器都设有阻止</span><span style="line-height: 150%; font-size: 16px;">&nbsp;Cookie&nbsp;</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">的功能。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">三、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp;&nbsp; </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们如何委托处理、共享、转让、公开披露您的个人及企业信息</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="text-decoration: underline; line-height: 150%; font-family: 宋体; font-size: 16px;">委托处理</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">为了向您提供人才服务系统的服务，我们可能会委托网站技术服务提供商帮助我们提供网站运营相关的技术服务和支持。在此过程之中，该第三方服务提供商会处理您的个人及企业信息，我们在与上述服务供应商合作时，没有也不会许可他们将我们与之共享的信息用于任何其他用途。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="text-decoration: underline; line-height: 150%; font-family: 宋体; font-size: 16px;">共享：</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">目前我们暂时不会向任何第三方共享您的个人及企业信息，如此后随着我们网站业务和功能的拓展，需要向第三方共享您的个人及企业信息的，我们将告知您第三方的类型，共享个人及企业信息的类型，使用个人及企业信息的目的、方式等情况，并取得您的同意。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="text-decoration: underline; line-height: 150%; font-family: 宋体; font-size: 16px;">转让：</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们不会将您的个人及企业信息转让给任何公司、组织和个人，但以下情况除外：</span><span style="line-height: 150%; font-size: 16px;"> </span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">a)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">事先获得您明确的同意或授权；</span><span style="line-height: 150%; font-size: 16px;"> </span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">b)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</span><span style="line-height: 150%; font-size: 16px;"> </span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">c)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">在涉及合并、收购、资产转让或类似的交易时，如果涉及到个人及企业信息转让，我们会要求新的持有您个人及企业信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="text-decoration: underline; line-height: 150%; font-family: 宋体; font-size: 16px;">公开披露：</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们不会主动公开你未自行公开的信息，除非遵循国家法律法规规定或者获得你的同意。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向有权机关披露您的个人信息。但我们保证，在上述情况发生时，我们会要求披露请求方必须出具与之相应的有效法律文件，并对被披露的信息采取符合法律和业界标准的安全防护措施。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;"></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">四、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp;&nbsp; </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们保护您的个人及企业信息</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">您的个人及企业信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人及企业信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们将尽力确保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及在互联网行业可能存在的各种恶意手段，不可能始终保证信息百分之百的安全。您需要了解，您接入我们服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">若不幸发生个人及企业信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和对您的补救措施，力求将损失最小化。我们将及时将事件相关情况以推送通知等方式告知您，难以逐一告知用户时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人及企业信息安全事件的处置情况，紧密配合政府机关的工作。</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">&nbsp;</span><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">五、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp;&nbsp; </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们如何存储您的个人及企业信息</span></strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">1.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">存储时间</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们会根据适用的法律、法规的要求，在达成本隐私政策所述目的所需的最短期限内保留您的个人及企业信息。在您撤回授权同意、删除个人及企业信息或注销您的账号时，我们将根据法律法规的要求删除或匿名化处理您的个人及企业信息。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">2.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">存储地点</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">原则上，我们在中华人民共和国境内收集和产生的您的个人信息，将存储在中国大陆境内。目前，我们不会将您的个人及企业信息向境外提供，如果之后随着我们的业务发展需要向境外传输您的个人及企业信息的，我们将按照法律规定在事前向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类的事项后，另行取得您的单独同意。并遵循法律法规的其他相关要求，以确保您的个人及企业信息受到充分保护。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;"><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">六、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp;&nbsp; </span></span></strong><strong>您的个人及企业信息权利</strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <br/>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">关于您的个人信息是如何被处理的，您享有以下权利，为行使您的权利，您可以通过本政策末尾“联系我们”一节所述方式联系我们，以提出相应请求：</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">1.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">查询权</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">如果您已经注册了人才服务系统账号，您可以通过人才服务系统中的个人中心界面以查询您的个人及企业信息。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">2.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">删除权</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">在以下情形中，您可以向我们提出删除您的个人及企业信息的请求：</span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">a)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">处理目的已实现、无法实现或者为实现处理目的不再必要；</span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">b)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">当我们停止提供产品或者服务，或者保存期限已届满；</span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">c)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">您撤回同意后；</span></span>
</p>
<p style="margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">d)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">若我们违反法律、行政法规或者违反约定处理个人信息；</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:62px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">e)<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">法律、行政法规规定的其他情形</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">当您要求从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息，且您要求我们删除信息后，我们不会再继续使用您的个人及企业信息。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">3.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">更改或撤销您的同意</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">您可以向我们提出更改或撤回您授权我们收集和处理您的个人及企业信息的范围，当您更改或撤回同意后，我们将不再处理相应的个人及企业信息。请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但您撤销授权的决定，将不会影响我们此前基于您的授权而开展的个人及企业信息处理。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">4.<span style="font: 16px &quot;Times New Roman&quot;;"> </span></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">响应您的上述请求</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">为保障安全，我们可能会先要求验证您的身份（要求您提供书面资料或其他方式），然后再处理您的上述请求。我们将在收到相关请求并验证您的身份后</span><span style="line-height: 150%; font-size: 16px;">15</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">个工作日内响应您的请求。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，或者涉及我们商业秘密的信息，我们可能会予以拒绝。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;"></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;"><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">七、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp;&nbsp; </span></span></strong><strong>未成年人保护</strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们的网站和服务只面向成人，</span><span style="line-height: 150%; font-size: 16px;">18</span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">岁以下的未成年人不应创建自己的账号。未取得未成年人的父母或其他监护人的同意，我们不会主动收集未成年人的个人信息。如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;"></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;"><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">八、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp;&nbsp; </span></span></strong><strong>本隐私政策更新</strong></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">我们可能依据法律法规变更或业务发展适时修订本隐私政策。我们将在修订后通过显著页面通知、公告或其他合理、可行的方式通知您。如果您重新同意隐私政策并选择继续使用我们的服务，即表示同意本隐私政策的修订内容亦对您有约束力。您可以随时在本平台查阅修改后的最新版本政策。</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。对于重大变更，我们还会提供更为显著的通知（包括我们会通过人才服务系统公示的方式进行通知）。本政策所指的重大变更包括但不限于：</span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0">
    <span style="font-size: 16px;">(1) <span style="font-family: 宋体; font-size: 16px;">我们的服务模式发生重大变化。如处理个人及企业信息的目的、处理的个人及企业信息类型、个人及企业信息的使用方式等；</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0">
    <span style="font-size: 16px;">(2) <span style="font-family: 宋体; font-size: 16px;">个人及企业信息共享、转让或公开披露的情况发生变化；</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0">
    <span style="font-size: 16px;">(3) <span style="font-family: 宋体; font-size: 16px;">您参与个人及企业信息处理方面的权利及其行使方式发生重大变化；</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0">
    <span style="font-size: 16px;">(4) <span style="font-family: 宋体; font-size: 16px;">我们负责处理个人及企业信息安全的责任部门、联络方式及投诉渠道发生变化时。</span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="font-size: 16px;"><span style="line-height: 150%; font-size: 16px;">&nbsp;<strong>九</strong></span><span style="line-height: 150%; font-family: 宋体; font-size: 16px;"><strong><span style="line-height: 150%; font-family: &quot;Times New Roman&quot;, serif; font-size: 16px;">、<span style="font: 16px &quot;Times New Roman&quot;;">&nbsp; </span></span></strong><strong><span style="line-height: 150%; font-family: 宋体; font-size: 16px;">联系我们</span></strong></span></span>
</p>
<p style="margin-top:0;margin-right:0;margin-bottom:21px;margin-left:25px;text-indent:0;line-height:150%">
    <span style="line-height: 150%; font-family: 宋体; font-size: 16px;">若您需要行使您的上述权利，或对本政策存在任何疑问或意见、建议或投诉，以及您的其他顾虑无法在此找到解答，可通过选择以下任意一种方式联系我们。</span>
</p>
<p style="text-indent:28px;line-height:150%">
    <span style="font-size: 16px;"><strong>联系方式如下：</strong></span>
</p>
<p style="text-indent:57px;line-height:150%">
    <span style="font-size: 16px;"><strong>运营方：</strong>创新管理标准化国际伙伴计划</span>
</p>
<p style="text-indent:57px;line-height:150%">
    <span style="font-size: 16px;"><strong>公共邮箱：</strong><span style="font-size: 16px;">info@imspp.org.cn</span></span>
</p>
<p style="text-indent:57px;line-height:150%">
    <span style="font-size: 16px;"><strong>联系电话：</strong>010-64754680</span>
</p>
<p>
    <br/>
</p>`;
      }
      // 用户服务协议
      if (val == 1) {
        this.textarea2 = `<h1 style="text-align:center"></h1>
<p style="text-align:center">
    <strong><span style="font-size: 24px;">用户服务协议</span></strong><span style="font-size:16px"><br/></span>
</p>
<p>
    <span style="font-size:16px"><br/></span>
</p>
<p>
    <span style="font-size:16px"><br/></span>
</p>
<p style="text-align: center;">
    <span style="font-size:16px">版本生效日期：2023年【06】月【16】日</span>
</p>
<p>
    <span style="font-size:16px"><br/></span>
</p>
<h1 style="text-align: left;">
    <strong><span style="font-size:16px">欢迎您使用创新与知识产权管理人才服务系统<span style="text-decoration:underline;">（下称“人才服务系统”）</span>的产品和服务。</span></strong>
</h1>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p>
    <strong><span style="font-size:16px">【重要提示】</span></strong>
</p>
<p>
    <strong><span style="font-size:16px">《用户服务协议》是您（以下也称“用户”）与人才服务系统运营方【创新管理标准化国际伙伴计划】之间关于您使用“人才服务系统”的服务（以下简称“服务”）所涉相关事项的法律协议。在使用人才服务系统运营方提供的各项服务之前，请您仔细阅读、理解《用户服务协议》（简称“本协议”），特别是以黑体加粗、下划线标识等其他合理方式提示您注意的可能与您利益有重大关系的条款，包括但不限于相关免除责任的条款、对权利进行限制的条款、法律适用和争议解决条款等。</span></strong>
</p>
<p>
    <strong><span style="font-size:16px">&nbsp;</span></strong>
</p>
<p>
    <strong><span style="font-size:16px">如果您不同意本协议的任意或全部条款，尤其是前述条款，请立即停止注册流程。一旦您通过浏览器打开人才服务系统页面点击确认或事实上使用人才服务系统提供的任意一项服务，均视为您已阅读、理解并同意签署本协议，并自愿接受并遵守本协议的全部约定。</span></strong>
</p>
<p>
    <strong><span style="font-size:16px">&nbsp;</span></strong>
</p>
<p>
    <strong><span style="font-size:16px">&nbsp;</span></strong>
</p>
<p>
    <strong><span style="font-size:16px">服务条款的确认和接纳：</span></strong>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">用户同意本协议的，即视为用户确认自己具有享受本系统服务等相应的权利能力和行为能力，能够独立承担法律责任。</span></strong>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">用户同意本协议的，即视为用户确认成为创新管理标准化国际伙伴计划项目的会员。</span></strong>
</p>
<p class="MsoListParagraph" style="text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">3.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，人才服务系统将在系统中通知公告栏目上刊载公告，通知予用户。<strong>如您不同意变更的内容，您应当于本协议变更生效之日起停止使用本服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用本服务，则视为您同意变更后的协议。</strong></span>
</p>
<p class="MsoListParagraph" style="text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">4.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方保留在中华人民共和国大陆地区施行法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容的权利。</span>
</p>
<p class="MsoListParagraph" style="text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">5.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><strong><span style="font-size:16px">账号注册：您应当具备中华人民共和国法律规定的必要、适当的民事权利能力和民事行为能力，人才服务系统运营方的要求完成注册。若您不具备前述与您行为相适应的民事权利能力和民事行为能力，则您需要在您监护人的陪同下完成注册。</span></strong><span style="font-size:16px">用户注册成功后，您将可以使用人才服务系统进行资质查询等服务；用户应当对以其用户账号进行的所有活动和事件负法律责任。</span>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">一、服务内容</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统服务的具体内容由人才服务系统运营方根据实际情况提供。</span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">与相关网络服务有关的设备（如个人电脑、手机有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。</span>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">二、服务变更、中断或终止</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">鉴于网络服务的特殊性，用户同意人才服务系统运营方有权随时变更、中断或终止部分或全部的服务（包括收费服务）。<strong>如变更、中断或终止的网络服务属于免费的服务，人才服务系统运营方无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费的服务，人才服务系统运营方应当在变更、中断或终止之前事先通知用户。</strong></span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">人才服务系统运营方需要定期或不定期地对平台或相关的设备进行检修或者维护，如因此类情况而造成所提供的服务在合理时间内的中断，人才服务系统运营方无需为此承担任何责任，但人才服务系统运营方应尽可能事先进行通告。</span></strong>
</p>
<p class="MsoListParagraph" style="text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">3.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">如发生下列任何一种情形，人才服务系统运营方有权随时中断或终止向用户提供本协议项下的服务（包括收费服务）而无需对用户或任何第三方承担任何责任：</span></strong>
</p>
<p style="margin-left:57px">
    <strong><span style="font-size:16px">3.1 </span></strong><strong><span style="font-size:16px">用户提供的个人资料不真实；</span></strong>
</p>
<p style="margin-left:57px">
    <strong><span style="font-size:16px">3.2 </span></strong><strong><span style="font-size:16px">用户违反本协议中规定的使用规则。</span></strong><span style="font-size:16px"> </span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">4.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><strong><span style="font-size:16px">若因用户违反本协议的约定，导致或产生第三方主张的任何索赔、要求或损失，应当自行负责处理由此产生的争议，并承担全部法律责任，若人才服务系统运营方因此遭受损失的，您应当一并赔偿。</span></strong>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">三、使用规则</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">用户在申请使用人才服务系统服务时，必须向人才服务系统运营方提供必要的准确的个人及企业资料，如个人及企业必要资料有任何变动，请务必及时更新。</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统账号所有权归人才服务系统运营方所有，用户仅拥有人才服务系统账号的有限使用权。<strong>用户需对其享有使用权的账号下所从事的所有行为承担责任，用户应妥善保管自己的账号，不得将人才服务系统账号转让、出借、出租、售卖或分享予他人使用，否则人才服务系统运营方有权选择根据实际情况暂时封停或永久查封此账号。</strong>当用户的账号或密码遭到未经授权的使用时，用户应当立即通知人才服务系统运营方，否则未经授权的使用行为均视为用户本人的行为。人才服务系统运营方为了保障用户的账号安全可能会定期或不定期采用不同的方式对用户的身份进行验证，包括但不限于要求验证、绑定您的手机号、电子邮箱等。如用户无法完成验证或拒绝验证的，人才服务系统运营方可合理怀疑用户的账号出现异常或被盗，并暂停向用户提供服务或采取进一步措施。因黑客行为或用户的保管疏忽导致账号、密码遭他人非法使用，人才服务系统运营方不承担任何责任。</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">3.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">用户同意人才服务系统运营方有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在人才服务系统的任何页面上投放广告），并且，用户同意接受人才服务系统运营方通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。</span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">4.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">用户在使用人才服务系统网络服务过程中，必须遵循以下原则：</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.1 </span><span style="font-size:16px">用户在使用人才服务系统的服务过程中，应遵守宪法法律，包括但不限于《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机小程序保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《网络安全法》等有关计算机及互联网规定的法律、法规；应遵守公共秩序，尊重社会公德，不得危害网络安全，不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。在任何情况下，人才服务系统一旦合理地认为用户存在上述行为的，可以在任何时候，不经事先通知终止向该用户提供服务；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.2 </span><span style="font-size:16px">遵守所有与网络服务有关的网络协议、规定和程序；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.3 </span><span style="font-size:16px">不得为任何非法目的而使用网络服务系统；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.4 </span><span style="font-size:16px">不得以任何形式使用人才服务系统网络服务侵犯平台的商业利益，包括但不限于发布非经人才服务系统许可的商业广告；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.5 </span><span style="font-size:16px">不得利用人才服务系统网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.6 </span><span style="font-size:16px">不得利用人才服务系统提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法信息资料；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.7 </span><span style="font-size:16px">不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">4.8 </span><span style="font-size:16px">不得利用人才服务系统网络服务系统进行任何不利于人才服务系统的行为。</span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">5.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方有权对用户使用人才服务系统服务的情况进行审查和监督。如用户在使用网络服务时违反任何上述规定，人才服务系统运营方或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">6.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方针对某些特定的人才服务系统服务的使用通过各种方式做出的任何声明、通知、警示等内容视为本协议的一部分，用户如使用该等人才服务系统网络服务，视为用户同意该等声明、通知、警示的内容。</span>
</p>
<p class="MsoListParagraph" style="text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">7.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">凡用户昵称中出现如下信息者（包括但不限于），平台有权进行屏蔽、锁定，甚至注销：</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.1 </span><span style="font-size:16px">使用严重违反国家法律及风俗，包含或暗藏反动、色情等信息（含符号、地址等）的昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.2 </span><span style="font-size:16px">使用党和国家领导人、古今中外比较有影响的名人、网络上知名人士的真实姓名、字、号、艺名、笔名、头衔等为昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.3 </span><span style="font-size:16px">使用国家机构、企事业单位、知名公司或品牌的名称及标识为昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.4 </span><span style="font-size:16px">含性别歧视、种族歧视、地域歧视等信息的昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.5 </span><span style="font-size:16px">含自侮辱、猥亵或者对他人进行侮辱、挑衅、漫骂、人身攻击等不文明、不健康信息的昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.6 </span><span style="font-size:16px">含易产生歧义、引起他人误解的信息的昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.7 </span><span style="font-size:16px">未获得人才服务系统运营方官方正式许可而使用带有人才服务系统名称的昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.8 </span><span style="font-size:16px">带有明显广告性质的昵称；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">7.9 </span><span style="font-size:16px">带有其它法律法规以及论坛禁止规则中所包含信息的昵称。</span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">8.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">用户行为规范</span>
</p>
<p style="margin-left:28px;text-indent:0">
    <span style="font-size:16px">人才服务系统运营方不允许违反法律法规及妨害平台秩序的行为，一经发现相关内容及账号将被取消用户资格并注销账号。</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1</span><span style="font-size:16px">违反法律法规</span>
</p>
<p style="margin-left:28px;text-indent:0">
    <span style="font-size:16px">人才服务系统运营方严格遵守《互联网信息服务管理办法》及相关法律法规，禁止包含以下信息的违法违规内容出现，以下情形中，我们可能会收集使用你的相关个人信息无需征求您的授权同意：</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.1 </span><span style="font-size:16px">反对宪法所确定的基本原则的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.2 </span><span style="font-size:16px">危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.3 </span><span style="font-size:16px">损害国家荣誉和利益的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.4 </span><span style="font-size:16px">煽动民族仇恨、民族歧视，破坏民族团结的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.5 </span><span style="font-size:16px">破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.6 </span><span style="font-size:16px">散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.7 </span><span style="font-size:16px">散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.8</span><span style="font-size:16px">侮辱或者诽谤他人，侵害他人合法权益的；</span>
</p>
<p style="margin-left:57px">
    <span style="font-size:16px">8.1.9 </span><span style="font-size:16px">含有法律、行政法规禁止的其他内容的。</span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p>
    <span style="font-size:16px">8.2 </span><span style="font-size:16px">用户账号违规</span>
</p>
<p style="margin-left:28px">
    <span style="font-size:16px">人才服务系统运营方严格遵守《互联网信息服务管理办法》及相关法律法规，保护用户的个人隐私。用户拥有设置个性化账号信息的权利(包括：昵称、头像等)，但不得设置含有以下内容的账号信息：</span>
</p>
<p style="margin-left:28px">
    <span style="font-size:16px">8.2.1 </span><span style="font-size:16px">违反国家法律法规的；</span>
</p>
<p style="margin-left:28px">
    <span style="font-size:16px">8.2.2 </span><span style="font-size:16px">包含人身攻击性质内容的；</span>
</p>
<p style="margin-left:28px">
    <span style="font-size:16px">8.2.3 </span><span style="font-size:16px">暗示二维码或其他链接的；</span>
</p>
<p style="margin-left:28px">
    <span style="font-size:16px">8.2.4 </span><span style="font-size:16px">包含其他非法信息的。</span>
</p>
<p style="margin-left:28px">
    <span style="font-size:16px">不得使用隐晦表达等方式规避以上限制。</span>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">四、知识产权</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">受国际版权公约、中华人民共和国著作权法、专利法、及其他知识产权方面的法律法规的保护，人才服务系统运营方的服务、界面、交互等元素、LOGO、商标、标识、图形、文字、音频、视频、肖像、图片、技术等的所有知识产权归北京国之合创新与知识产权研究院所有和享有。“知识产权”包括在专利法、版权法、商标法、反不正当竞争法中等法律规定的任何和所有权利、任何和所有其它所有权以及其中的任何和所有应用、更新、扩展和恢复。</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方为提供网络服务而使用的任何小程序（包括但不限于系统中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于人才服务系统运营方，未经北京国之合创新与知识产权研究院的许可，用户不得对该人才服务系统进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。用户不得向任何单位或个人出售、转让、授权人才服务系统的代码、技术接口及开发工具等。</span>
</p>
<p class="MsoListParagraph" style="text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">3.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">用户只能在本协议以及人才服务系统运营方明示授权的范围内容使用人才服务系统服务。未经人才服务系统运营方事先书面许可，用户不得以任何营利性或非营利性的目的修改、复制、传播、传送、发行、转移、销售人才服务系统服务所使用的技术、材料以及产品/服务内容等或创造、制作与这些内容有关的派生产品或衍生品。否则，用户自行承担因此而造成对人才服务系统运营方或其他人的全部损害。</span>
</p>
<p class="MsoListParagraph" style="text-indent:32px">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">4.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方对其自制内容和其他通过授权取得的独占内容（包括但不限于文字、图片、系统架构、测试题目等）享有完全知识产权，未经人才服务系统运营方的许可，任何单位和个人不得私自复制、转载、引用、链接、抓取、传播和提供观看服务或者有其他侵犯人才服务系统知识产权的行为。否则，人才服务系统运营方将追究侵权行为人的法律责任。</span>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">五、免责声明</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">用户明确同意其使用人才服务系统网络服务所存在的风险将完全由其自己承担；因其使用人才服务系统网络服务而产生的一切后果也由其自己承担，人才服务系统对用户不承担任何责任。</span></strong>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px"><br/></span></strong>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">用户明确同意允许人才服务系统运营方查看、使用用户提交的信息（包括但不限于用户姓名、单位信息等）。</span></strong>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">3.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">用户理解并确认，人才服务系统的服务是按照现有技术和条件所能达到的现状提供的，人才服务系统运营方无法保证其所提供的服务毫无瑕疵，人才服务系统不对提供的服务（含技术和信息）做出任何明示或暗示的承诺或保证，包括但不限于质量、稳定、正确、及时、完整、连贯、安全等，但人才服务系统运营方承诺将不断提升服务质量及服务水平，为用户提供更加优质的服务。</span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">4.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由人才服务系统运营方实际控制的任何内容，人才服务系统运营方不承担任何责任。</span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">5.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">为了改善用户体验、保证产品、服务的安全性及产品功能的一致性，人才服务系统运营方可能会对系统进行更新。您在进入系统前，清除浏览器缓存或在浏览器中刷新人才服务系统页面，否则人才服务系统运营方并不保证其一定能正常使用。<strong>对于因不可抗力或人才服务系统不能控制的原因造成的网络服务中断或其它缺陷，人才服务系统运营方不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</strong></span>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">6.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">用户同意，对于人才服务系统运营方向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，以及无论任何原因导致服务中止、终止的，人才服务系统运营方无需承担任何违约、补偿、赔偿责任：</span></strong>
</p>
<p style="margin-left:28px">
    <strong><span style="font-size:16px">5.1 </span></strong><strong><span style="font-size:16px">人才服务系统运营方向用户免费提供的各项服务；</span></strong>
</p>
<p style="margin-left:28px">
    <strong><span style="font-size:16px">5.2 </span></strong><strong><span style="font-size:16px">人才服务系统运营方向用户赠送的任何产品或者服务；</span></strong>
</p>
<p style="margin-left:28px">
    <strong><span style="font-size:16px">5.3 </span></strong><strong><span style="font-size:16px">人才服务系统运营方向收费服务用户附赠的各种产品或者服务。</span></strong>
</p>
<p>
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">7.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">其他用户(或网友)所上传的相片、文章或讨论区发言内容，由该用户(或网友)自行对该相片、文章或讨论区发言内容担保其知识性、专业性以及合法性。</span>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">六、协议修改</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">人才服务系统运营方有权随时修改本协议的任何条款，一旦本协议的内容发生变动，人才服务系统运营方会直接在人才服务系统上公布修改之后的协议内容，该公布行为视为人才服务系统运营方已经通知用户修改内容。人才服务系统运营方也可通过其他适当方式向用户提示修改内容。</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">如果不同意人才服务系统运营方对本协议相关条款所做的修改，用户有权停止使用服务。如果用户继续使用服务，则视为用户接受人才服务系统运营方对本协议相关条款所做的修改。</span>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">七、法律管辖</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">本协议的订立、执行和解释及争议的解决均适用中国法律并受人才服务系统运营方所在地人民法院管辖。</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <strong><span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span style="font-size:16px">如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向人才服务系统运营方所在地有管辖权的人民法院提起诉讼。</span></strong>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">八、其他规定</span>
</h1>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">1.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px;text-indent:0">
    <span style="font-size:16px">&nbsp;</span>
</p>
<p class="MsoListParagraph" style="margin-left:24px">
    <span style="font-size:16px">2.<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp; </span></span><span style="font-size:16px">如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</span>
</p>
<h1>
    <span style="font-size:21px;line-height:240%">九、联系方式</span>
</h1>
<p style="margin-left:28px;text-indent:0">
    <span style="font-size:16px">当您有个人信息相关问题或其他的投诉、建议等，可以通过如下方式与人才服务系统运营方联系。人才服务系统运营方将尽快审核所涉及内容，并于15个工作日内对于您的问题、投诉、建议等进行回复：</span>
</p>
<p style="margin-left:28px;text-indent:0">
    <span style="font-size:16px;">运营方：创新管理标准化国际伙伴计划</span>
</p>
<p style="margin-left:28px;text-indent:0">
    <span style="font-size:16px">公共邮箱：info@imspp.org.cn</span>
</p>
<p style="margin-left: 28px; text-indent: 0px;">
    <span style="font-size:16px">联系电话：010-64754680</span>
</p>`;
      }
      this.guanbi = true;
      document.querySelector("body").setAttribute("style", "overflow:hidden");
      var hidebg = document.getElementById("hidebg");
      hidebg.style.display = "block"; //显示隐藏层
    },

    know() {
      this.guanbi = false;
      document.querySelector("body").removeAttribute("style");
      document.getElementById("hidebg").style.display = "none";
    },

    //    看不清换一张
    Changeone() {
      this.initTable(); //输出为：newValue  最新修改的值
    },

    //验证手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },

    //获取验证码
    initTable() {
      enterpriselogincode().then((res) => {
        if (res.code == "1000") {
          var register = res.data;
          let str = register.img.replace(/\. +/g, "");
          str = str.replace(/[\r\n]/g, "");
          this.register.image = str;
          this.ruleForm.check_uuid = res.data.uuid;
          this.register.uuid = register.uuid;
          this.$nextTick(function () {
            this.register.image = str;
            this.register.uuid = register.uuid;
          });
          console.log(this.register);
        } else {
          console.log(1);
        }
      });
    },

    showPass(value) {
      this.visible = !this.visible;
    },
    showPassa(value) {
      this.visiblea = !this.visiblea;
    },
    gosignin() {
      this.$router.push({ name: "Signin" });
    },
    logo() {
      this.$router.push({ name: "index" });
    },
    goindex() {
      this.$router.push({ name: "index" });
    },

    handleLogin() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let encPass = this.$Base64.encode(this.ruleForm.passwd); //base64加密
          let encPasss = this.$Base64.encode(encPass); //  这里是第二次加密
          let obj = {
            // passwd: encPasss, //密码
            // account: this.ruleForm.account, //账户
            // email: this.ruleForm.email, //邮箱
            // tel: this.ruleForm.tel, //电话号码
            // check_uuid: this.ruleForm.check_uuid, //验证码uuid
            // check_code: this.ruleForm.check_code, //验证码内容
            // creditCode: sessionStorage.getItem("creditCode"), //社会统一识别代码
            userName: this.ruleForm.userName,
            sex: this.ruleForm.sex,
            idcardType: this.ruleForm.idcardType,
            idcardNum: this.ruleForm.idcardNum,
            mobilePhone: this.ruleForm.mobilePhone,
            email: this.ruleForm.emails,
            passwd: encPasss,
            check_code: this.ruleForm.checkCode,
            // check_uuid: this.ruleForm.check_uuid,
          };
          console.log(obj);
          registUser(obj).then((res) => {
            console.log("注册", res);
            //注册接口 报错邮箱格式有误
            if (res.code == "1000") {
              sessionStorage.setItem("user", JSON.stringify(res.data));
              sessionStorage.setItem("passwd", JSON.stringify(encPasss));
              sessionStorage.setItem("token", res.data.token);
              sessionStorage.setItem("userId", res.data.id);
              // this.$message.success("注册成功");
              this.$router.push({ name: "index" }); //跳转主页
              console.log(res);
            } else {
              this.$notify.error({
                title: "错误",
                message: res.msg,
              });
              //如果登陆失败刷新验证码
              this.initTable();
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
// .ipt {
//   /deep/ .el-input__inner::placeholder {
//    content: "请输入邮箱";
//   }
// }
.controls {
  margin-top: 20px;
  display: flex;
  align-items: center;

  height: 30px;
  width: 100%;
  font-size: 14px;
  justify-content: center;

  input {
    height: 16px;
    width: 16px;
  }

  // span{

  //   // cursor: pointer;
  // }
}

// .logo {
//   height: 10%;
//   width: 100%;
//   display: flex;
//   align-items: center;
//   padding-left: 100px;
//   font-size: 30px;
//   p{
//     cursor:pointer;
//   }
// }

.box_mast {
  height: 90%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ullogo {
  li {
    height: 100px;

    dl {
      display: flex;
      justify-content: center;
      align-items: center;

      dd {
        margin-left: 20px;
        font-size: 20px;
        color: #333333;
      }
    }
  }
}

.rowEditor {
  position: relative;
  margin-bottom: 10px;

  .fa-user-o,
  .fa-lock {
    position: absolute;
    left: 15px;
    top: 13px;
  }

  .fa-eye,
  .fa-eye-slash {
    position: absolute;
    right: 15px;
    top: 13px;
  }
}

.hell {
  height: 100%;
  width: 100%;
  text-align: center;

  .header {
    width: 100%;
    padding-left: 54px;
    font-weight: bold;
    display: flex;
    height: 80px;
    box-sizing: border-box;
    // line-height: 80px;
    background: #fff;
    align-items: center;
    font-size: 19px;
    color: rgb(38, 38, 39);
    box-shadow: 2px 3px 2px 2px #f0f0f0;
    margin-bottom: 3px;

    img {
      width: 90px;
      height: 60px;
      background-size: 100%;
    }

    p {
      // cursor: pointer;
      line-height: 25px;
      // width: 380px;
      font-size: 19px;
      text-align: center;
      // padding-left: 15px;
    }
  }
}

.login {
  background: url("../assets/regis-bg.png") 100% 100% no-repeat;
  // width: 50%;
  display: flex;
  height: calc(100% - 83px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 100%;
  background-size: cover;
  position: relative;
}

.title {
  margin: 0 auto 30px auto;
  text-align: center;
  color: #333333;
  font-size: 20px;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 600px;
  padding: 25px 25px 5px 25px;

  .regTitle {
    width: 112px;
    height: 28px;
    font-size: 24px;
    font-weight: 400;
  }
}

// .login-tip {
//   font-size: 13px;
//   text-align: center;
//   color: #bfbfbf;
// }

// .login-code {
//   width: 33%;
//   display: inline-block;
//   height: 38px;

//   //float: right;
//   img {
//     cursor: pointer;
//     vertical-align: miscrimgddle;
//   }
// }

.register {
  float: right;
  color: rgb(24, 144, 255);
}

.looky {
  position: relative;
}

.scrimg {
  position: absolute;
  right: 20px;
  top: 10px;
}

a {
  color: #1890ff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
}

.yanzhenma {
  display: flex;
  justify-content: space-between;
  // align-items: center;
  width: 600px;
  margin: auto;

  p {
    font-size: 12px;
  }
}

.login_div {
  width: 1199px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 1px 2px 1px 1px #f0f0f0;
  // position: relative;
}

.goindex {
  position: absolute;
  top: 23px;
  right: 23px;
  font-size: 14px;
  color: #1890ff;
  cursor: pointer;
}

.Bulletframe {
  background: #ffffff;
  // background: url(../image/iframe/xxtz.png) no-repeat;
  // background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .pas {
    font-size: 16px;
    color: #999999;
    text-align: left;
    width: 100%;
    margin-left: 230px;
    margin-top: 11px;
  }

  dl {
    height: 170px;
    display: flex;
    flex-direction: column;
    align-content: center;
    background: #98c6fd;
    width: 100%;
    // opacity: 0.9;
    border-radius: 5px;
    font-weight: bold;

    dt {
      height: 7px;
      width: 100%;
      margin-top: 50px;
      border-radius: 5px;

      img {
        height: 50px;
        width: 50px;
      }
    }

    dd {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 60px;

      p {
        color: rgb(64, 158, 255);
        height: 30px;
        font-size: 20px;
      }
    }
  }

  height: 700px;
  width: 1100px;

  // background-color: #dee7f7;
  //    background: #fff;
  // opacity: 0.9;

  left: 50%;
  margin: -350px 0 0 -550px;
  position: fixed;
  top: 50%;
  border-radius: 5px;

  .guanbi {
    width: 100%;

    text-align: right;
    font-size: 25px;
    margin-top: 1px;
    margin-right: -30px;
    text-align: right;
    display: flex;
    justify-content: right;
    margin-right: 20px;

    span {
      display: inline-block;
      margin-right: 100px;
      height: 50px;

      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

#hidebg {
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: #000;
  width: 100%;
  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  filter: alpha(opacity=60);
  /*设置透明度为60%*/
  opacity: 0.6;
  /*非IE浏览器下设置透明度为60%*/
  display: none;
  /* http://www.jb51.net */
  z-index: 99;

  left: 0;
  height: 100%;
  // position: fixed;
  // top: 0;
}

.fwbtext {
  margin: 10px;
  height: 90%;
  width: 90%;

  overflow-y: auto;
  text-align: left;
  z-index: 999;
}

::v-deep .el-form--label-left .el-form-item__label {
  text-align: right;
  height: 38px;
  line-height: 38px;
}

::v-deep .el-form-item--mini .el-form-item__content,
.el-form-item--mini .el-form-item__label {
  height: 38px;
  line-height: 38px;
  padding-bottom: 2px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .read>.el-form-item__content>.el-form-item__error {
  left: 120px;
}

::v-deep.el-form-item--mini {
  position: relative;
}

::v-deep.el-form-item--mini .el-form-item__error:before {
  position: absolute;
  content: "";
  background: url(../assets/icon/point.png);
  background-size: cover;
  left: -20px;
  top: 60%;
  width: 14px;
  height: 14px;
  transform: translateY(-50%);
  // margin-right:10px
}

::v-deep.el-form-item--mini .el-form-item__error {
  padding-top: 5px;
  margin-left: 20px;
}

::v-deep.login-form .el-input {
  height: 38px;
  width: 100%;
  padding-bottom: 2px;
}

::v-deep.el-input--mini .el-input__inner {
  height: 38px;
  line-height: 38px;
}

.IdCard /deep/.el-input--mini .el-input__inner {
  height: 38px;
  margin-bottom: -2px;
}

::v-deep.read>.el-form-item__content>.el-form-item__error {
  left: 120px;
  margin-top: 2px;
}
</style>
